// extracted by mini-css-extract-plugin
export default {"booth":"BoothName_booth__vVFqi"};